import axios from 'axios';
import { DataManagement } from './DataManagement';
import Global from './Global';
import { default as decode } from 'jwt-decode';
import { ICJWTToken } from './Interfaces';

export default class BaseServices {
  dataManagement: DataManagement;
  constructor() {
    this.dataManagement = new DataManagement();
  }
  async get(url: string, params: any, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .get(url, { params: params, headers: headers, ...config })
      .then(response => response.data)
      .catch(error => this.handleError(error));
  }

  async get2(url: string, params: any, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .get(url, { params: params, headers: headers, ...config })
      .then(response => response.data)
      .catch(error => error);
  }

  async post(url: string, params: Object, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .post(url, params, { headers: headers, ...config })
      .then(response => response.data)
      .catch(err => {
        if (err?.response?.data?.message) {
          return err?.response?.data?.message;
        }

        return err?.message ?? err;
      });
  }

  async post2(url: string, params: Object, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .post(url, params, { headers: headers, ...config })
      .then(response => response)
      .catch(error => {
        console.log('error', JSON.stringify(error));
        if (error.response) {
          console.log('errorres', error.response);

          // Request made and server responded
          if (url.includes('login') && error.response.status === 400)
            return error.response.data;
          if (url.includes('signup') && error.response.status === 400)
            return error.response.data;
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        return error?.message ?? error;
      });
  }

  async postFormData(url: string, files: any) {
    await this.checkTokenValidity();
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
      },
    };

    const formData = new FormData();
    if (files && files.length > 0 && files[0].file) {
      formData.append('file', files[0].file);
    } else {
      formData.append('file', files);
    }
    return axios
      .post(url, formData, config)
      .then(response => response.data)
      .catch(error => this.handleError(error));
  }

  async postFormDataForMultipleFiles(url: string, files: any) {
    await this.checkTokenValidity();
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
      },
    };

    const formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
    }

    return axios
      .post(url, formData, config)
      .then(response => response.data)
      .catch(error => this.handleError(error));
  }

  async put(url: string, params: Object, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .put(url, params, { headers: headers, ...config })
      .then(response => response.data)
      .catch(error => this.handleError(error));
  }

  async patch(url: string, params: Object, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .patch(url, params, { headers: headers, ...config })
      .then(response => response.data)
      .catch(error => {
        return error?.message ?? error;
      });
  }

  async delete(url: string, params: Object, config: Object) {
    await this.checkTokenValidity();
    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
    };
    return axios
      .delete(url, { data: params, headers: headers, ...config })
      .then(response => response.data)
      .catch(error => {
        return error?.message ?? error;
      });
  }

  handleError(error: any) {
    let exception: any = {};
    exception = error ?? null;
    return exception ?? 'Cant load data! Please check internet connection';
  }

  async checkTokenValidity() {
    return new Promise((resolve, reject) => {
      const token = this.dataManagement.getData('userToken');
      const refreshToken = this.dataManagement.getData('refreshToken');

      if (!token || token === null || !refreshToken || refreshToken === null) {
        return resolve(false);
      }

      let isExpired = false;

      const decodedToken: ICJWTToken = decode(token);
      let currentDate = new Date();
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        isExpired = true;
      }

      if (!isExpired) {
        return resolve(false);
      }

      const username = this.dataManagement.getData('useremail');
      let params = { username: username, refreshToken: refreshToken };
      let config = {};

      let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.dataManagement.getData('userToken'),
      };
      return axios
        .post(Global.ServicesConstants.core.auth.refreshToken, params, {
          headers: headers,
          ...config,
        })
        .then(response => {
          this.dataManagement.storeData('userToken', response.data);
          resolve(true);
        })
        .catch(err => {
          localStorage.clear();
          reject(err?.message ?? err);
        });
    });
  }
}
